<template>
  <div v-if="yearlyCalendar !== null" id="yearlyCalendar">
    <!-- Inline Months View --->
    <div v-if="calendarStyle === 'allMonthsInline'" class="months-inline-view">
      <div class="year-options">
        <div v-for="(yearOption, indx) in yearOptions" :key="indx" @click="handleYearClick(yearOption)"
          :class="{'year-option': true, 'selected': (selectedYear === yearOption)}">
          {{yearOption}}
        </div>
      </div>
      <table cellpadding="0" cellspacing="0" border="0">
        <tbody>
          <tr>
            <td v-for="(month, indx) in yearlyCalendar.months" :key="indx" class="month-label">
              <div @click="handleMonthClick(month)"
                :class="{'cover': true,
              'selected': (selectedMonth !== null && month.id === selectedMonth),
              'greyscale': (!calendarData[selectedYear]) || ((calendarData[selectedYear]) && (typeof (calendarData[selectedYear][`${selectedYear}-${month.id}`]) !== 'object'))}">
                {{month.title.short}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss" src="./yearly-calendar.scss"></style>
<script src="./yearly-calendar.js"></script>
